import _ from 'lodash'
import { addIdToLocations } from './markers'
import { isDefaultFilter } from '../libs/filter'
import { fetchWithRetry } from 'libs/fetchWithRetry'

export function makeFilterForMarkerFetching(f) {
    if (!f || _.isEmpty(f) || isDefaultFilter(f)) return ''

    const status = (f.showOnlyAvailable)
        ? 'available'
        : 'available,unavailable,occupied,unknown'

    const includeUnsupported = (f.onlyAccessibleWithCard)
        ? 'excludeUnsupportedTokens'
        : 'includeUnsupportedTokens'

    const minPower = f.minPower || '0'

    const connectors = (_.isArray(f.connectors) && f.connectors.length > 0)
        ? f.connectors.join(',')
        : 'Type1,TepcoCHAdeMO,Type3,Type2Combo,Type2,Domestic'

    return `/${status}/${connectors}/${minPower}/${includeUnsupported}`
}

export function fetchMarkers(bounds, filter) {
    const f = makeFilterForMarkerFetching(filter)
    const url = `/api/map/v2/markers/${bounds.minLng}/${bounds.maxLng}/${bounds.minLat}/${bounds.maxLat}/${bounds.zoom}${f}`

    return fetchWithRetry({ url }).then(addIdToLocations)
}

export function fetchSingleLocation(id) {
    return fetchWithRetry({ url: `/api/map/v2/locations/${id}` })
}

export function searchLocationsBySerial(serial) {
    return fetchWithRetry({ url: `/api/map/v2/locations/search/${serial}` })
}
